import React from "react";
import { Location } from "react-router-dom";
import { useLoadScopes } from "./auth";
import { getPageTitle } from "./getPageTitle";
export function useGetPageTitle(location: Location | undefined | string) {
  const scopes = useLoadScopes();
  let pathname: string;
  if (typeof location === "string") {
    pathname = location;
  } else {
    pathname = location?.pathname ?? "";
  }

  const pageTitle = React.useMemo(() => getPageTitle(pathname, scopes), [
    pathname,
    scopes,
  ]);

  return pageTitle;
}
